module.exports = __webpack_public_path__ + "front/img/c3.01fc2c02.png";